import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import StatCard from '../../components/user-management/StatCard';
import UserList from '../../components/user-management/UserList';
import { useSelector } from 'react-redux';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { fetchUsersData } from '../../api/user';
import useLoader from '../../hooks/useLoader';
import Loader from '../../components/common/Loader/Loader';
import { userCardData } from './userCardData';
import StatCardSkeleton from './StatCardSkeleton';
import Tooltip from '@mui/material/Tooltip';
import CountrySelect from '../../components/country-select/CountrySelect';
import FilterState from '../../components/country-select/FilterState';
import ProfileCompilationDropdown from '../../components/ProfileCompilationDropdown';
const Dashboard = () => {
  const [data, setData] = useState([]);
  const filter = useSelector((state) => state.filter);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, searchTerm, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);
  const { loading, startLoading, stopLoading } = useLoader();

  const fetchData = async () => {
    try {
      startLoading();
      await fetchUsersData(filter, userCardData, setData);
      stopLoading();
    } catch (err) {
      console.error('Error while loading user data', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filterWithoutUTM)]);

  // Calculate total value and percentages for each item
  const updatedData = data.map((item) => {
    // Check if at least one gender count is present
    if (
      item.maleCount !== undefined ||
      item.femaleCount !== undefined ||
      item.otherCount !== undefined
    ) {
      const male = item.maleCount || 0;
      const female = item.femaleCount || 0;
      const other = item.otherCount || 0;

      const totalCount = male + female + other;
      const malePercentage = totalCount
        ? ((male / totalCount) * 100).toFixed(2) + '%'
        : '0%';
      const femalePercentage = totalCount
        ? ((female / totalCount) * 100).toFixed(2) + '%'
        : '0%';
      const otherPercentage = totalCount
        ? ((other / totalCount) * 100).toFixed(2) + '%'
        : '0%';

      if (item.title === 'Average Age') {
        // Average only among available gender counts (not always 3)
        const nonZeroGenders = [male, female, other].filter((x) => x > 0);
        const averageAge =
          nonZeroGenders.length > 0
            ? (nonZeroGenders.reduce((a, b) => a + b, 0) / nonZeroGenders.length).toFixed(1)
            : 'N/A';
        return {
          ...item,
          male: malePercentage,
          female: femalePercentage,
          other: otherPercentage,
          value: averageAge !== 'N/A' ? `${averageAge}` : 'N/A',
        };
      }

      return {
        ...item,
        value: totalCount.toLocaleString(),
        male: malePercentage,
        female: femalePercentage,
        other: otherPercentage,
      };
    } else {
      return item;
    }
  });

  return (
    <div>
      <div className="d-flex gap-16 align-items-center">
        <span>
          <img
            src="/assets/images/admin-panel/user-management-icon.svg"
            className="img-fluid"
            alt=""
          />
        </span>
        <div className="">
          <div className="d-flex gap-10 text-black align-items-center fw-bold font-p font-36">
            {/* <Tooltip title="Go Back" arrow placement="top">
                <Link
                  to="/"
                  className="w-32-px h-32-px radius-8 object-fit-cover d-flex justify-content-center align-items-center fw-semibold text-xs bg-neutral-900 text-white"
                >
                  <iconify-icon icon="line-md:arrow-small-left" width="24" height="24"></iconify-icon>
                </Link>
              </Tooltip> */}
            User Management
          </div>
          <p>Manage and empower users for a premium dating experience.</p>
        </div>
      </div>

       
 {/* <ProfileCompilationDropdown /> */}
      <SearchFilter isHideUserManagement={false} />
      {loading ? (
        <div className="gap-16 updatedData">
          {[...Array(8)].map((_, i) => (
            <StatCardSkeleton key={i} />
          ))}
        </div>
      ) : (
        <div className="gap-16 updatedData">
          {updatedData.map((item, index) => (
            <StatCard key={index} data={item} />
          ))}
        </div>
      )}

      <div className="mt-32">
        <UserList showProfileColumn />
      </div>
    </div>
  );
};

export default Dashboard;
